module.exports = __webpack_public_path__ + "static/media/abstract steuart 3.64ced2ee.png";